// ** Icons Import
import {
  Box,
  Mail,
  User,
  Circle,
  Shield,
  Calendar,
  FileText,
  Clipboard,
  ShoppingCart,
  MessageSquare,
  Archive,
  Folder,
  ShoppingBag,
  Image,
  UserCheck,
  Briefcase,
  List,
  Map,
  CheckSquare,
  Bell,
  CreditCard,
  Package,
  Crosshair,
  MapPin,
  Aperture,
  Users,
  DivideSquare,
  Hexagon,
  Star,
  Link,
  Settings,
  Lock,
  Coffee
} from 'react-feather'

export default [
  {
    id: 'apps',
    title: 'Apps',
    icon: <Box />,
    children: [
      {
        id: 'admins',
        title: 'Admins',
        icon: <Briefcase size={20} />,
        navLink: '/apps/admin/list'
      },
      {
        id: 'owners',
        title: 'Owners',
        icon: <Aperture size={20} />,
        navLink: '/apps/owner/list'
      },
      {
        id: 'users',
        title: 'Users',
        icon: <Users size={20} />,
        navLink: '/apps/user/list'
      },
      {
        id: 'category-type',
        title: 'Category Types',
        icon: <Package size={20} />,
        navLink: '/apps/category-type/list'
      },
      {
        id: 'delivery-type',
        title: 'Delivery Types',
        icon: <Hexagon size={20} />,
        navLink: '/apps/delivery-type/list'
      },
      {
        id: 'choice-groups',
        title: 'Choice Groups',
        icon: <Box size={20} />,
        navLink: '/apps/choice-group/list'
      },
      {
        id: 'restaurant',
        title: 'Restaurants',
        icon: <ShoppingBag size={20} />,
        navLink: '/apps/restaurant/list'
      },
      {
        id: 'drink',
        title: 'Drinks',
        icon: <Coffee size={20} />,
        navLink: '/apps/drink/list'
      },
      {
        id: 'review',
        title: 'Reviews',
        icon: <Star size={20} />,
        navLink: '/apps/review/list'
      },
      {
        id: 'orders',
        title: 'Orders',
        icon: <Clipboard size={20} />,
        navLink: '/apps/orders/list'
      },
      {
        id: 'slider',
        title: 'Sliders',
        icon: <Image size={20} />,
        navLink: '/apps/slider/list'
      },
      {
        id: 'coupons',
        title: 'Coupons',
        icon: <CreditCard size={20} />,
        navLink: '/apps/coupons/list'
      },
      {
        id: 'reports',
        title: 'Reports',
        icon: <Clipboard size={20} />,
        navLink: '/apps/reports/list'
      },
      {
        id: 'social',
        title: 'Social Links',
        icon: <Link size={20} />,
        navLink: '/apps/social/list'
      },
      {
        id: 'privacy',
        title: 'Privacy Policy',
        icon: <Shield size={20} />,
        navLink: '/apps/privacy-policy/list'
      },
      {
        id: 'terms',
        title: 'Terms & Conditions',
        icon: <FileText size={20} />,
        navLink: '/apps/terms-conditions/list'
      },
      {
        id: 'setting',
        title: 'Settings',
        icon: <Settings size={20} />,
        navLink: '/apps/setting'
      },
      // {
      //   id: 'role',
      //   title: 'Roles & Permissions',
      //   icon: <Lock size={20} />,
      //   navLink: '/apps/role/list'
      // },
      {
        id: 'notification',
        title: 'Notifications',
        icon: <Bell size={20} />,
        navLink: '/apps/notification/list'
      }
    ]
  }
]
